import AppHeader from 'components/AppHeader'
import { mapGetters } from 'vuex'

export default {
  components: {
    AppHeader
  },
  data: function () {
    return {
      callbackFlag: false
    }
  },
  created () {
    this.search()
  },
  computed: {
    ...mapGetters([
      'proposeTaskDetail'
    ])
  },
  methods: {
    search: function () {
      const callback = () => {
        this.callbackFlag = true
      }
      this.$store.dispatch('PROPOSE_TASK_DETAIL', {id: this.$route.params.id, callback: callback})
    },
    formatDate: function (date) {
      const reg = /(\d{4})-(\d{2})-(\d{2})/
      return date.replace(reg, '$1年$2月$3日')
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/scripts/propose-task-detail.js